import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { firebaseApp } from '../config/firebaseConfig';

export const getUserTipo = async () => {
  const auth = getAuth(firebaseApp);
  const { currentUser } = auth;

  if (!currentUser) throw new Error('Usuário não autenticado');

  const db = getFirestore(firebaseApp);
  const userRef = doc(db, 'usu_usuario', currentUser.uid);
  const userSnap = await getDoc(userRef);

  if (userSnap.exists()) {
    const userData = userSnap.data();
    return userData;
  }
  throw new Error('Usuário não encontrado');
};
